export default {
  reviewDialog: {
    width: "s",
    title: "作废原因",
    component: () =>
      import("@/mods/archive/dataReview/dialog/DataReviewDialog"),
  },
};
